// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3r5pG{height:auto;margin:0;padding:.7rem 1.2rem;text-align:left}._3r5pG .btn-inner{-ms-flex-pack:left;justify-content:left}._3F8xs{background-color:#f5f9ff!important;border:none;font-weight:lighter}._3UvNA{-ms-flex-wrap:nowrap;flex-wrap:nowrap}._10ZHG{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._10ZHG,._10ZHG:after{height:24px;height:2.4rem;width:24px;width:2.4rem}._10ZHG:after{background:#fff;border-radius:50%;content:\" \";left:0;opacity:.2;position:absolute;top:0}._3wWPs{fill:#fff;height:12px;height:1.2rem;margin-top:-1.2rem;position:relative;width:12px;width:1.2rem;z-index:0}._36fR1{fill:#c9cfdc}._36fR1:before{opacity:1}._22eZz{height:100%;width:100%}._1Pyrl{line-height:1}._2Sv4g{font-size:14px;font-size:1.4rem;margin-bottom:.3rem}._2qeC0{color:#c9cfdc;white-space:normal}._1iZ5t{font-size:12px;font-size:1.2rem;font-weight:400;opacity:.8;padding-bottom:1px}", ""]);
// Exports
exports.locals = {
	"root": "_3r5pG",
	"root--notActive": "_3F8xs",
	"content": "_3UvNA",
	"icon__wrapper": "_10ZHG",
	"icon": "_3wWPs",
	"icon--notActive": "_36fR1",
	"icon__arrow": "_22eZz",
	"label": "_1Pyrl",
	"label--lead": "_2Sv4g",
	"label--notActive": "_2qeC0",
	"label--secondary": "_1iZ5t"
};
module.exports = exports;
